import React from 'react';
import { Grid, Paper, makeStyles } from '@material-ui/core';
import { InfoCard, Link } from '@backstage/core-components';
import { WIKI_SECTIONS } from './wikiSections';

const useStyles = makeStyles(theme => ({
  tabLink: {
    display: 'block',
    height: '100%',
    borderRadius: theme.shape.borderRadius,
    textDecoration: 'none',
    color: 'inherit',
    '&:hover': { textDecoration: 'none' },
    '&:focus-visible': {
      outline: `3px solid ${theme.palette.primary.main}`,
      outlineOffset: 2,
    },
  },
  tabCard: {
    display: 'flex',
    alignItems: 'center',
    minHeight: 56,
    padding: theme.spacing(1.5, 2),
    fontWeight: 600,
    color: theme.palette.primary.main,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    transition: 'background-color 150ms ease',
    '$tabLink:hover &': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

export const WikiSectionsCard = () => {
  const classes = useStyles();
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <InfoCard title="Wiki contents">
          <Grid container spacing={2}>
            {WIKI_SECTIONS.map(tab => (
              <Grid item xs={6} sm={4} md={3} lg={2} key={tab.name}>
                <Link to={tab.docsPath} className={classes.tabLink}>
                  <Paper variant="outlined" className={classes.tabCard}>
                    {tab.name}
                  </Paper>
                </Link>
              </Grid>
            ))}
          </Grid>
        </InfoCard>
      </Grid>
    </Grid>
  );
};
